(function (customerPortal, $) {

    /* Add Select2 to IjkCustomerNumbers select field*/
    customerPortal.AddSelectIjkCustomerNumbers = function (selectedAttribute) {

        $.fn.select2.amd.require(['select2/selection/search'], function (Search) {
            var oldRemoveChoice = Search.prototype.searchRemoveChoice;

            Search.prototype.searchRemoveChoice = function () {
                oldRemoveChoice.apply(this, arguments);
                this.$search.val('');
            };

            $(selectedAttribute).select2({
                theme: "bootstrap-5",
                dropdownParent: $('#modalcontainer'),
                language: "nl"
            });
        });
    }

    customerPortal.InitCustomerPortalThirdPartySettingsGrid = function(subscriptionKey, showCustomerNumber) {
        let configuredColumns = [
            { data: "email", name: "Email", title: "E-mail", orderable: true, searchable: showCustomerNumber },
            { data: "ijkCustomerNumber", name: "IjkCustomerNumber", title: "Klantnummer", defaultContent: "", orderable: true, searchable: showCustomerNumber },
            { data: "typeClientQuestionDescription", name: "TypeClientQuestionDescription", title: "Type klantvraag", defaultContent: "", orderable: false, searchable: false },
            { responsivePriority: -1, defaultContent: "", orderable: false, searchable: false }
        ];

        if(!showCustomerNumber) {
            configuredColumns.splice(1,1);
        }

        $('#customerPortalThirdPartySettingsGrid').DataTable(datatable.defaultDataTableOptions({
            ajax: {
                url: `/CustomerPortal/CustomerPortal/SearchThirdPartySettings?subscriptionKey=${subscriptionKey}`
            },
            columns: configuredColumns,
            columnDefs: [
                {
                    targets: -1,
                    width: '100px',
                    className: 'text-end text-nowrap',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        return `
                        <a data-bs-toggle="modal" data-bs-target="#modalcontainer" class="btn btn-outline-primary fas fa-edit" title="Wijzigen" href="/CustomerPortal/ThirdPartySettings/Edit?key=${globalCore.urlEncode(full.key)}&subscriptionKey=${subscriptionKey ?? ""}"></a>
                        <a data-bs-toggle="modal" data-bs-target="#modalcontainer" class="btn btn-outline-primary fas fa-trash-alt" title="Verwijderen" href="/CustomerPortal/ThirdPartySettings/Delete?key=${globalCore.urlEncode(full.key)}&subscriptionKey=${subscriptionKey ?? ""}"></a>`;
                    }
                }
            ]
        }));
    }

}(window.customerPortal = window.customerPortal || {}, jQuery));
